import React, { useState, useEffect } from "react";
import MyDatePicker from "../Common/my-date-picker";
import "./test.scss";
import { DATE_FORMAT } from "../../constants/app.constants";

const HighgroundDatePicker = (props) => {
  const {
    dateFormat = DATE_FORMAT,
  } = props;
  return (
    <MyDatePicker
      {...props}
      dateFormat={dateFormat}
    >
      <div className={props.className}>
      {props.icon && <img alt="" className="mr-1" src={props.icon} />}
      <input
        disabled={props.disableDatePicker}
        tabIndex={-1}
        type="text"
        placeholder={`${
          props.placeholder ? props.placeholder : "Choose date"
        }`}
        isError={props?.isError}
        errorText={props?.errorText}
        className="border-none pl-2 bg-transparent-imp w-100"
        value={props.selected}
      />
      </div>
    </MyDatePicker>
  )
};

export default HighgroundDatePicker;

